interface NoResultsProps {
  illustration: string
  message: string
}

function NoResults({ message, illustration }: NoResultsProps) {
  return (
    <div className='flex h-full flex-col items-center'>
      <img src={illustration} className='mt-28 mb-4 size-24' alt={message} />
      <div className="w-full text-center text-sm font-semibold text-text-secondary">{message}</div>
    </div>
  )
}

export default NoResults